package com.example.mystybag.e5AiSearch.helpers

actual object E5TokenizerProvider {
    private var cached: E5Tokenizer? = null

    actual suspend fun get(ctx: PlatformContext, assetName: String): E5Tokenizer {
        cached?.let { return it }
        val tok = WebTokenizer.load(tokenizerUrl = assetName)
        cached = tok
        return tok
    }
}
